import { Text, Circle, Icon, VStack, useToast } from '@chakra-ui/react';
import React from 'react';

import { consts as tapeBuilderConsts } from '@finley-technologies/tape-builder';

import { useQAContext } from './calcAgentQA/QAContext';
import { RenderNodeProps, useNodeColors } from './RenderNodeProps';
import { successToastConfig } from 'packages/common-frontend/constants';
import { FiPlayCircle } from 'react-icons/fi';

export const OperationNode = ({
  nodeText,
  nodeType,
  selected = false,
  hasInputs = false,
  draggable = false,
  nodeId,
}: RenderNodeProps) => {
  const { generateTape } = useQAContext();

  let baseSize = 100;
  if (selected) {
    baseSize += 15;
  }
  if (hasInputs) {
    baseSize += 40;
  }

  const circleSize = `${baseSize}px`;
  const playIconSize = '80px';
  const toast = useToast();

  const successToast = (message: string) => {
    toast({
      ...successToastConfig,
      id: `${nodeId}-success`,
      title: message,
    });
  };

  const canQA =
    hasInputs &&
    nodeId &&
    tapeBuilderConsts.isTapeBuilderNativeOperationType(nodeType);

  const {
    bgColor,
    textColor,
    borderColor,
    selectedBorderColor,
    iconColor,
    unSelectedBorderSize,
    selectedBorderSize,
  } = useNodeColors();

  return (
    <Circle
      draggable={draggable}
      onDragStart={(event) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        // eslint-disable-next-line no-param-reassign
        event.dataTransfer.effectAllowed = 'move';
      }}
      size={circleSize}
      bg={bgColor}
      color={textColor}
      border={
        selected
          ? `${selectedBorderSize} solid`
          : `${unSelectedBorderSize} solid`
      }
      borderColor={selected ? selectedBorderColor : borderColor}
      _hover={{
        cursor: 'pointer',
      }}
    >
      <VStack>
        {canQA && (
          <Icon
            as={FiPlayCircle}
            color={iconColor}
            boxSize={playIconSize}
            onClick={async () => {
              const result = await generateTape(nodeId);
              if (result.isValid) {
                successToast(
                  'Generated Tape Successfully. Proceed to next node to download the tape.',
                );
              }
            }}
          />
        )}
        <Text fontSize="md" fontWeight="light">
          {nodeText}
        </Text>
      </VStack>
    </Circle>
  );
};
